class SpikesPdpWishlist extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.scope = this.closest('.shopify-section') || document;
    this.button?.addEventListener('click', this.onClick);
    this.observer = new MutationObserver(this.sync);
    this.observer.observe(this.scope, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
    this.sync();
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.onClick);
    this.observer?.disconnect();
  }

  get vitalsButton() {
    return this.scope.querySelector('.Vtl-WishlistInlineButton');
  }

  onClick = () => {
    this.vitalsButton?.click();
  };

  sync = () => {
    const vitals = this.vitalsButton;
    this.hidden = !vitals;
    if (!vitals || !this.button) return;
    const active = vitals.classList.contains('Vtl-WishlistInlineButton--active');
    this.classList.toggle('is-active', active);
    this.button.setAttribute('aria-pressed', String(active));
    const label = vitals.getAttribute('aria-label');
    if (label && this.button.getAttribute('aria-label') !== label) this.button.setAttribute('aria-label', label);
  };
}

if (!customElements.get('spikes-pdp-wishlist')) {
  customElements.define('spikes-pdp-wishlist', SpikesPdpWishlist);
}
